import { defineStore } from 'pinia';
import { commissionService } from '../services/commission-service';

export const useCommissionStore = defineStore('commission-store', {
    state: () => ({
        data: null,
        loading: false,
        error: null,
    }),
    actions: {
        async boot() {
            if (this.loading) return;
            this.loading = true;
            this.error = null;
            try {
                const { data } = await commissionService.get();
                this.data = data;
            } catch (e) {
                this.error = e;
            } finally {
                this.loading = false;
            }
        },
    },
});